import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler extends Sentry.SentryErrorHandler {
  constructor(private router: Router) {
    // Customize Sentry's internal error handler behavior
    super({
      showDialog: false,
    });
  }

  override handleError(error: any): void {
    const originalError = error?.originalError || error;

    // Reload on chunk loading errors (fix broken lazy-loaded modules)
    if (
      originalError?.message?.includes('Loading chunk') ||
      originalError?.name === 'ChunkLoadError'
    ) {
      console.warn('Detected chunk load error — reloading app...');
      window.location.reload();
      return;
    }

    // Add useful context (e.g. current route)
    if (this.router) {
      Sentry.setTag('route', this.router.url);
    }

    // Delegate to Sentry's built-in error handler
    super.handleError(error);
  }
}
